import { useParams } from "react-router-dom";

import { transientLogFileName, transientLogStoragePath } from "../api/urls";

export const useJobLogFileUrl = (configId?: number) => {
  const { projectId } = useParams();
  if (!projectId || configId == null) return { file: null };

  return {
    file: {
      name: transientLogFileName(configId),
      path: transientLogStoragePath(projectId, configId),
      url: "",
    },
  };
};
